module.exports = __webpack_public_path__ + "static/media/jennifer.7a6bc100.jpg";